export default __webpack_public_path__ + "static/monshin_600-bde3e499fe25c7febfd692e88aef1a67.jpg";